<template>
  <div>
    <Form ref="searchForm" inline>
      <Form-item>
        <Input
          style="width:240px"
          placeholder="请输入导航名称关键字"
          v-model="searchCondition.name"
          clearable
          @keydown.native.prevent.enter="search(1)"
        ></Input>
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <Button style="margin-right:20px;" type="primary" @click="add({},'新增导航')">添加导航</Button>
    <div class="content">
      <TreeGrid :rows="navs" :columns="column" :maxLevel="2">
        <template slot-scope="{ row }" slot="action">
          <Button v-if="!row.parent_id" type="text" size="small" @click="add({},'添加子集',row)">添加子集</Button>
          <span v-if="!row.parent_id">-</span>
          <Button type="text" size="small" @click="add(row,'编辑导航')">编辑</Button>
          <span>-</span>
          <Button type="text" size="small" @click="close(row)">{{row.status == 1 ?'关闭':'开启'}}</Button>
          <span>-</span>
          <Button type="text" size="small" @click="del('one',row.id)">删除</Button>
        </template>
      </TreeGrid>
    </div>
    <!-- 新增/编辑属性 -->
    <Modal v-model="showModel" :title="modalTitle" width="700">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
        <Form-item label="上级导航">{{getParentNavName(formValidate.parent_id)}}</Form-item>
        <Form-item label="导航名称" prop="name">
          <Input :maxlength="20" v-model="formValidate.name" placeholder="最多可输入20个字" />
        </Form-item>
        <Form-item label="链接类型">
          <RadioGroup v-model="formValidate.is_outer">
            <Radio label="0">内部链接</Radio>
            <Radio label="1">外部链接</Radio>
          </RadioGroup>
        </Form-item>
        <Form-item label="链接地址">
          <Select
            v-show="formValidate.is_outer == 0"
            placeholder="请选择内部链接"
            v-model="formValidate.url"
            style="width:200px"
          >
            <Option v-for="(item,index) in menus" :value="item.link" :key="index">{{ item.value }}</Option>
          </Select>
          <Input
            v-show="formValidate.is_outer == 1"
            v-model="formValidate.url"
            placeholder="请输入"
            clearable
          />
        </Form-item>
        <FormItem label="链接说明">
          <div style="color:#ccc;">
            <div>外部链接举例：https://www.xx.com</div>
            <div>内部链接举例：课程：/course，资讯：/news，会员：/vip，一对一约课：/oto，在线测评：/exam，下载：/download，名师：/show-teachers，图书：/book</div>
          </div>
        </FormItem>
        <Form-item label="新窗口">
          <RadioGroup v-model="formValidate.is_target">
            <Radio label="0">否</Radio>
            <Radio label="1">是</Radio>
          </RadioGroup>
        </Form-item>
        <Form-item label="导航状态">
          <RadioGroup v-model="formValidate.status">
            <Radio label="1">开启</Radio>
            <Radio label="0">关闭</Radio>
          </RadioGroup>
        </Form-item>
        <Form-item label="导航排序" prop="sort">
          <Input type="number" v-model="formValidate.sort" placeholder="请输入" />
        </Form-item>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModel = false">取消</Button>
        <Button type="primary" @click="save('formValidate')">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import expandRow from "./ExpandRow";
export default {
  name: "NavSetting",
  components: {
    // eslint-disable-next-line
    expandRow
  },
  data() {
    return {
      column: [
        {
          title: "导航名称",
          key: "name",
          align: "center"
        },
        {
          title: "链接地址",
          key: "url",
          align: "center"
        },
        {
          title: "新窗口",
          key: "is_target_name",
          width: 100,
          align: "center"
        },
        {
          title: "链接类型",
          key: "is_outer_name",
          align: "center",
          width: 180
        },
        {
          title: "状态",
          key: "status_name",
          width: 100,
          align: "center"
        },
        {
          title: "顺序",
          key: "sort",
          width: 100,
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          width: 240
        }
      ],
      searchCondition: {
        name: ""
      },
      navs: [],
      showModel: false,
      modalId: "",
      modalTitle: "",
      loading: false,
      menus: [
        //{ value: "首页", link: "/" },
        { value: "课程", link: "/course" },
        { value: "资讯", link: "/news" },
        //{ value: "会员", link: "/vip" },
        //{ value: "一对一", link: "/oto" },
        //{ value: "在线评测", link: "/exam" },
        { value: "下载", link: "/download" },
        { value: "名师", link: "/show-teachers" },
        { value: "图书", link: "/book" },
        { value: "问答", link: "/question" },
        { value: "章节练习", link: "/exercise" },
        { value: "模拟考试", link: "/exam/simulation" }
      ],
      formValidate: {
        name: "",
        is_outer: "0",
        url: "",
        is_target: "0",
        status: "1",
        sort: "",
        parent_id: "0"
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "导航名不能为空！"
          }
        ],
        sort: [
          {
            required: true,
            message: "请输入排序"
          },
          {
            type: "number",
            message: "请输入数字",
            transform(value) {
              return Number(value);
            }
          }
        ]
      }
    };
  },
  methods: {
    search(flag) {
      if (flag == 0) {
        this.searchCondition.name = "";
      }
      this.getNav();
    },
    add(_data = {}, _title = "编辑导航", parentRow) {
      this.showModel = true;
      this.modalTitle = _title;
      this.modalId = _data.id || "";
      this.formValidate.name = _data.name || "";
      this.formValidate.is_outer = _data.is_outer || "0";
      this.formValidate.is_outer += "";
      this.formValidate.is_target = _data.is_target || "0";
      this.formValidate.is_target += "";
      this.formValidate.url = _data.url || "";
      this.formValidate.status = _data.status || "1";
      this.formValidate.status += "";
      this.formValidate.sort = _data.sort || "";
      if (parentRow) {
        this.formValidate.parent_id = parentRow.id;
      } else {
        this.formValidate.parent_id = _data.parent_id ? _data.parent_id : "0";
      }
    },
    /**
     * 新增/编辑属性
     */
    save(name) {
      this.$refs[name].validate(valid => {
        if (!valid) return;
        let params = {
          name: this.formValidate.name,
          url: this.formValidate.url,
          is_target: this.formValidate.is_target,
          is_outer: this.formValidate.is_outer,
          status: this.formValidate.status,
          parent_id: this.formValidate.parent_id,
          sort: this.formValidate.sort
        };
        if (this.modalId != "") {
          // 编辑
          params.id = this.modalId;
          this.$http.put(`/api/navSetting`, params).then(() => {
            this.search(1);
            this.showModel = false;
          });
        } else {
          //新增
          this.$http.post("/api/navSetting", params).then(() => {
            this.search(1);
            this.showModel = false;
          });
        }
      });
    },
    del(_type, _id) {
      let ids = "";
      if (_type == "one") {
        ids = _id;
      } else {
        if (this.selectList.length == 0) {
          this.$Message.error("请至少选择一个属性");
          return false;
        } else {
          let arr = [];
          this.selectList.forEach(i => {
            arr.push(i.uid);
          });
          ids = arr.join(",");
        }
      }
      this.$Modal.confirm({
        title: "删除",
        content: "<p>确定要删除该属性吗？</p>",
        onOk: () => {
          this.delete(ids);
        },
        onCancel: () => {}
      });
    },
    delete(_ids) {
      this.$http.delete(`/api/navSetting/${_ids}`).then(() => {
        this.search(1);
      });
    },
    close(row) {
      this.$http
        .post(`/api/navSetting/status/${row.id}`, {
          id: row.id
        })
        .then(() => {
          this.search(1);
        });
    },
    getParentNavName(parentID) {
      if (parentID == 0) {
        return "一级导航";
      } else {
        for (const i of this.navs) {
          if (i.id == parentID) return i.name;
        }
      }
      return "";
    },
    getNav() {
      this.loading = true;
      this.$http.get(`/api/navSetting`, this.searchCondition).then(res => {
        this.loading = false;
        res.forEach(i => {
          i.is_outer_name = i.is_outer == 0 ? "内部链接" : "外部链接";
          i.is_target_name = i.is_target == 0 ? "否" : "是";
          i.status_name = i.status == 0 ? "关闭" : "开启";
          if (i.parent_id != 0) {
            for (let j = 0; j < res.length; j++) {
              if (res[j].id == i.parent_id) {
                if (!res[j].hasOwnProperty("children")) {
                  res[j].children = [];
                }
                res[j].children.push(i);
                break;
              }
            }
          }
        });
        let newRes = [];
        res.forEach(item => {
          if (item.parent_id == 0) {
            if (!item.hasOwnProperty("children")) {
              item._disableExpand = true;
            }
            newRes.push(item);
          }
        });
        this.navs = newRes;
      });
    }
  },
  created() {
    this.getNav();
  }
};
</script>
<style lang="scss" scoped>
.ivu-checkbox-wrapper {
  margin-right: 50px;
}
</style>
